//import security from '@/plugins/security'
export default {
  config: {},
  oidcSettings:{
    authority: "http://default_route",
    clientId: 'cf_view',
    redirectUri: "http://default_route"+'/oidc-callback',
    responseType: 'code',
    scope: 'openid profile cf_api.full_access IdentityServerApi',
    automaticSilentRenew: true,
    silentRedirectUri: "http://default_route"+"/silent-renew-oidc",
    silentSignIn:false,
  },
  hubConnection: undefined,

  userRole: undefined,
  userAccounts:undefined,
  
  snackSettings:{
    trigger: false,
    text: "La operación ha sido exitosa!",
    timeout: undefined,
    redirect: undefined
  },

  investmentModalTrigger: false,
  investmentData:{
    projectId: undefined,
    creditsAvailable: 0,
    creditPrice: 0
  },

  fundingCampaings:[],
  modals:[]
}